
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button
} from "@chakra-ui/react";

import { Pie } from "react-chartjs-2";
import { Chart, ArcElement, Title, Tooltip, Legend } from "chart.js";
import { useTranslation } from "react-i18next";

Chart.register(ArcElement, Title, Tooltip, Legend);



const SurveyAnswerStatusModal = ({ dataAnswerStatusSurvey, isOpen, onClose }) => {
 
  const {t} = useTranslation();
  const { expertThatHaveResponse = 0, expertThatNotHaveResponse = 0 } = dataAnswerStatusSurvey;
  const totalExperts = expertThatHaveResponse + expertThatNotHaveResponse;

  const percentHaveResponse = totalExperts > 0 ? (expertThatHaveResponse / totalExperts) * 100 : 0;
  const percentNotHaveResponse = totalExperts > 0 ? (expertThatNotHaveResponse / totalExperts) * 100 : 0;

  const hasData = totalExperts > 0; // Controllo se ci sono dati validi

  const data = hasData
    ? {
        labels: [
          t('survey.surveyAnswerStatusModal.haveResponded')+' ('+ (percentHaveResponse.toFixed(1))+'%)',
          t('survey.surveyAnswerStatusModal.haveNotResponded')+' ('+ (percentNotHaveResponse.toFixed(1))+'%)',
        ],
        datasets: [
          {
            label: t('survey.surveyAnswerStatusModal.numberExperts'),
            data: [expertThatHaveResponse, expertThatNotHaveResponse],
            backgroundColor: ["#36A2EB", "#FF6384"],
            borderColor: ["#FFFFFF", "#FFFFFF"],
            borderWidth: 1,
          },
        ],
      }
    : null;

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: t('survey.surveyAnswerStatusModal.expertResponse') },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            let value = data.datasets[0].data[tooltipItem.dataIndex];
            let percentage = ((value / totalExperts) * 100).toFixed(1);
            return `${value} esperti (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('survey.surveyAnswerStatusModal.statusSurveyResponse')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {hasData ? (
            <Pie data={data} options={options} />
          ) : (
            <p style={{ textAlign: "center", fontSize: "1.2em", color: "#666" }}>
              {t('survey.surveyAnswerStatusModal.noDataAvailableSurvey')}
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={onClose}>
            {t('survey.surveyAnswerStatusModal.close')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};



export default SurveyAnswerStatusModal;
